// API
// https://talker-stage.lifehacker.ru/docs/api/v2?docuser=lifehacker&docpwd=iD8fuHxTuf
import type { Logger } from '@devhacker/shared/libs/logger';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';
import type { ITalkerApi } from '~/types/api/talker';
import { API_TIMEOUT, TALKER_API_URL } from '~/constants/config';

import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { parseJsonBigIntIds } from '@devhacker/shared/libs/fetch/parseJsonBigIntIds';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): ITalkerApi => {
  const talkerFetch = createAxiosLikeFetch({
    baseURL: TALKER_API_URL,
    timeout: API_TIMEOUT,
    parseResponse: parseJsonBigIntIds, // без этого API может вернуть 200 код и html
    headers: {
      'Content-Type': 'application/json',
    },
    ...createLoggerInterceptors($logger, 'talker'),
  });

  return {
    fetchBestComments() {
      return talkerFetch('/api/comments/top?limit=1');
    },

    fetchLastComments() {
      return talkerFetch('/api/comments/last?limit=3');
    },

    fetchCommentsBySlug(slug: string) {
      // format_ver=1 означает, что ответ будет плоским, без children
      const url = `/api/v2/comments/by-post-name/post/${slug}?format_ver=1&sort=oldest`;
      return talkerFetch(url);
    },

    fetchComments(postId, limit = 4, sortType = 'trending') {
      // format_ver=1 означает, что ответ будет плоским, без children
      const url = `/api/v2/comments/post/${postId}?sort=${sortType}&format_ver=1&limit=${limit}`;
      return talkerFetch(url);
    },
    fetchAmpComments(postId, sortType = 'trending') {
      // format_ver=1 означает, что ответ будет плоским, без children
      const url = `/api/v2/comments/post/${postId}?sort=${sortType}&format_ver=1`;
      return talkerFetch(url);
    },
  };
};
